import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@ufc/core'
import { routeTree } from './routeTree.gen'
import { store } from './store'
import './styles/index.css'
import './lib/i18n'

// Router context type - includes store for loaders
export interface RouterContext {
  store: typeof store
}

// Create the router instance with context
const router = createRouter({
  routeTree,
  context: {
    store,
  },
})

// Register the router instance for type safety
declare module '@ufc/core' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
